<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Novo Intinerário</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div [formGroup]="form" class="pb-2 pt-3 mt-4">
    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Área Tarrifário</mat-label>
        <mat-select formControlName="tariffArea">
          @for (item of listArea; track item) {
            <mat-option [value]="item.value">{{ item.description }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button class="btn-icon" (click)="googleSearch('origin')">
        <mat-icon>search</mat-icon>
      </button>
    </div>

    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Descrição</mat-label>
        <input matInput formControlName="description" />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>CEP</mat-label>
        <input
          matInput
          (input)="getAddressByPostalCode()"
          (blur)="getAddressByPostalCode()"
          formControlName="postalCode"
        />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Latitude</mat-label>
        <input matInput formControlName="latitude" />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Longitude</mat-label>
        <input matInput formControlName="longitude" />
      </mat-form-field>
    </div>

    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-7/12" appearance="outline">
        <mat-label>Logradouro</mat-label>
        <input matInput formControlName="street" />
      </mat-form-field>

      <mat-form-field class="input-tg w-2/12" appearance="outline">
        <mat-label>Número</mat-label>
        <input matInput formControlName="number" />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Bairro</mat-label>
        <input matInput formControlName="neighborhood" />
      </mat-form-field>
    </div>

    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-4/12" appearance="outline">
        <mat-label>Complemento</mat-label>
        <input matInput formControlName="complement" />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Cidade</mat-label>
        <input matInput formControlName="city" />
      </mat-form-field>

      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Estado</mat-label>
        <input matInput formControlName="state" />
      </mat-form-field>

      <mat-form-field class="input-tg w-2/12" appearance="outline">
        <mat-label>País</mat-label>
        <input matInput formControlName="country" />
      </mat-form-field>
    </div>

    <div class="flex justify-between gap-4 items-center">
      <mat-form-field class="input-tg w-4/12" appearance="outline">
        <mat-label>Hora da Parada</mat-label>
        <input matInput formControlName="horaParada" mask="Hh:m0:s0" [dropSpecialCharacters]="false" />
      </mat-form-field>

      <mat-form-field class="input-tg w-4/12" appearance="outline">
        <mat-label>Tempo de Permanência</mat-label>
        <input matInput formControlName="tempoPermanencia" mask="Hh:m0:s0" [dropSpecialCharacters]="false" />
      </mat-form-field>

      <mat-form-field class="input-tg w-4/12" appearance="outline">
        <mat-label>Atividades</mat-label>
        <input matInput formControlName="atividades" />
      </mat-form-field>
    </div>

    <div class="flex justify-end">
      <button
        mat-flat-button
        class="btn-tg w-1/5"
        [disabled]="!checkForm() || loading"
        (click)="saveItem()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          @if (edit) {
            Editar
          } @else {
            Adicionar
          }
        }
      </button>
    </div>
  </div>
</mat-card>
